import { Box, Divider, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { usePortal } from "../../../../../context/PortalsContext";
import { useToast } from "../../../../../context/ToastContext";
import { getTranslationsForSectionAttribute } from "../../../../../services/api/apiClient";
import { TranslationResult } from "../../../../../services/api/types/portalConfiguration/translations";
import { brand } from "../../../../../theme/themePrimitives";
import { fromCamelCase } from "../../../../../utils/helpers";
import { EditModal } from "./components/EditModal";

interface TranslationTabSectionContentProps {
  translations: TranslationResult[];
  img: string;
  setTranslationsArray: React.Dispatch<
    React.SetStateAction<TranslationResult[]>
  >;
}

export const TranslationTabSectionContent: React.FC<
  TranslationTabSectionContentProps
> = ({ translations, img, setTranslationsArray }) => {
  const [openModal, setOpenModal] = useState(false);
  const [translationResult, setTranslationResult] = useState<
    TranslationResult[]
  >([]);
  const [selectedAttribute, setSelectedAttribute] =
    useState<TranslationResult>();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const { portals } = usePortal();

  const fetchData = async (selectedAttribute: TranslationResult) => {
    try {
      setLoading(true);
      if (portals.selectedPortal && selectedAttribute) {
        const data: TranslationResult[] =
          await getTranslationsForSectionAttribute(
            portals.selectedPortal.portalUid,
            selectedAttribute?.tabId,
            selectedAttribute?.tabSectionKey,
            selectedAttribute?.attributeKey
          );
        setTranslationResult(data);
      }
    } catch (error: any) {
      console.log("Error:", error);
      showToast(error.response.data, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {translations.map((translation, index) => {
        return (
          <React.Fragment key={index}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                p: 2,
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: 150,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography>
                    {fromCamelCase(translation.attributeKey)}
                  </Typography>
                  <Typography
                    onClick={() => {
                      setOpenModal(true);
                      fetchData(translation);
                      setSelectedAttribute(translation);
                    }}
                    sx={{ cursor: "pointer", "&:hover" : {textDecoration: 'underline'} }}
                    color={brand[600]}
                  >
                    Edit translation
                  </Typography>
                </Box>
                <Box sx={{ flexGrow: 1 }}>
                  <TextField
                    fullWidth
                    id={translation.attributeValue}
                    type="text"
                    disabled
                    value={translation.attributeValue}
                    variant="outlined"
                    size="small"
                    placeholder="Default text"
                    sx={{ height: "100%" }}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  borderRadius: "8px",
                  height: 150,
                  width: "100%",
                }}
                component="img"
                src={img}
                alt={translation.attributeValue}
              ></Box>
            </Box>
            <Divider />
          </React.Fragment>
        );
      })}
      {selectedAttribute && (
        <EditModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          loading={loading}
          translations={translationResult}
          selectedAttribute={selectedAttribute}
          setTranslationsArray={setTranslationsArray}
        />
      )}
    </>
  );
};
